import React, { ReactNode } from "react";
import LoginLeftIcon from "../Icons/LoginLeftIcon.png";

interface AuthLayoutProps {
    children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
    return (
        <div className="tw-bg-[#e8eff3] tw-flex tw-flex-row tw-h-screen tw-w-full tw-overflow-hidden">
            {/* Left Panel - Hidden on Mobile */}
            {/* 
        Standardized Layout:
        - Width: md:basis-7/12 (approx 58%)
        - Background: #03234a (Solid)
        - Content: Standardized Marketing Text & Illustration
      */}
            <div className="tw-hidden md:tw-flex md:tw-basis-7/12 tw-flex-col tw-items-center tw-justify-center tw-bg-[#03234a] tw-relative tw-p-12 tw-text-white tw-bg-cover tw-bg-center tw-bg-no-repeat">
                <div className="tw-max-w-2xl tw-text-center tw-z-10">
                    <img
                        src={LoginLeftIcon}
                        alt="Illustration"
                        className="tw-w-3/4 tw-mx-auto tw-mb-12"
                    />
                    <h1 className="tw-text-4xl tw-font-bold tw-mb-6 tw-leading-tight">
                        Accelerated Data Insights. Made Simple.
                    </h1>
                    <p className="tw-text-xl tw-font-light tw-leading-relaxed">
                        We transform your domain experts and data engineers to a high performing
                        team, focusing on understanding and deriving value out of your key data
                        assets.
                    </p>
                </div>
                {/* Optional overlay for consistency if we ever add bg image back, but kept clear for now */}
                <div className="tw-absolute tw-inset-0 tw-bg-[#03234a]/10"></div>
            </div>

            {/* Right Panel - Form Content */}
            {/* 
        Standardized Layout:
        - Width: Flex-1 (Remaining space)
        - Background: #e8eff3 (Light Blue/Gray to match Login preference)
        - Padding: Consistent px-6 py-12 / md:px-16
      */}
            <div className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-[#e8eff3] tw-px-6 tw-py-12 md:tw-px-16 tw-w-full tw-relative tw-overflow-y-auto">
                {children}
            </div>
        </div>
    );
};

export default AuthLayout;
